import * as React from "react";
const AddSmall = ({ size, ...props }) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 18 18", fill: "currentColor", width: size || "18", height: size || "18", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M10 9 10 5 9 5 9 9 5 9 5 10 9 10 9 14 10 14 10 10 14 10 14 9z" }));
AddSmall.displayName = "AddSmall";
var AddSmall_default = AddSmall;
export {
  AddSmall_default as default
};
